import React from "react";
import { PermissionWrapper, Dropdown } from "components";

// Підкомпонент комірки "Наявність"
const PresenceCell = ({
  item,
  editing,
  setEditing,
  handleUpdate,
  options,
  getLabel,
}) => (
  <PermissionWrapper
    requiredPermission="traps:edit"
    fallback={<td>{getLabel(item.presence)}</td>}
  >
    <td
      onDoubleClick={() => {
        if (item.auto) return;
        setEditing({
          field: "presence",
          value: item.presence || options[0].value,
        });
      }}
      title={item.auto ? "Авто-режим увімкнено" : ""}
    >
      {editing.field === "presence" && !item.auto ? (
        <Dropdown
          options={options}
          selected={editing.value}
          onChange={(selectedValue) => handleUpdate("presence", selectedValue)}
          mode="select"
          placeholder="Виберіть присутність..."
          autoFocus
        />
      ) : (
        <span className={item.auto ? "auto-presence" : ""}>
          {getLabel(item.presence)}
        </span>
      )}
    </td>
  </PermissionWrapper>
);

export default PresenceCell;
